import { FLOW_STATES } from './flowDefinition';
import { createVerificationTimeline } from './verificationScenario';

/**
 * Deterministic stand-in for a live verification feed. The simulation clock pulls
 * the events of the slice of time it just advanced through, which is what keeps
 * pause/resume exact. A real-time source only has to push the same
 * `{ nodeId, state }` events and expose the trails still in flight.
 */
const createMockVerificationEventSource = (bid) => {
    const timeline = createVerificationTimeline(bid);

    return {
        duration: timeline.duration,

        getEventsBetween(fromTime, toTime) {
            return timeline.stateEvents.filter((event) => (
                event.at > fromTime && event.at <= toTime
            ));
        },

        getEdgeTrailsAt(time) {
            return timeline.signals.reduce((trails, signal) => {
                if (time < signal.startAt) return trails;

                const isTravelling = time < signal.endAt;
                const isProcessing = time < signal.settleAt;
                const progress = isTravelling
                    ? (time - signal.startAt) / signal.duration
                    : 1;

                return [
                    ...trails,
                    {
                        edgeId: signal.edgeId,
                        id: signal.id,
                        progress,
                        showSignal: isProcessing,
                        state: isProcessing ? FLOW_STATES.processing : signal.result,
                    },
                ];
            }, []);
        },
    };
};

export default createMockVerificationEventSource;
